'use client';

import { useEffect } from 'react';

import { MIXPANEL_APP_FEATURES, mixpanelEvents } from '@/shared/constants/mixpanel-events';
import { APP_ROUTES } from '@/shared/constants/navigation';
import { useIdleIntercom } from '@/shared/hooks/use-intercom-widget';
import { emitMixpanelEvent } from '@/shared/utils/mixpanel-utils';

import { REDIRECT_PATH } from '@/utils/constants';

import { MCP_FAQ_DATA } from '../../constants/mcp-content';
import { McpStructuredData } from '../common/mcp-structured-data';
import { CTASection } from '../views/cta-section';
import { FAQSection } from '../views/faq-section';
import { FooterSection } from '../views/footer-section';
import { HeaderSection } from '../views/header-section';
import { McpCapabilitiesSection } from '../views/mcp-capabilities-section';
import { McpClientSetupSection } from '../views/mcp-client-setup-section';
import { McpComparisonSection } from '../views/mcp-comparison-section';
import { McpHowToConnectSection } from '../views/mcp-how-to-connect-section';
import { McpHeroSection } from '../views/mcp-hero-section';
import { MARKETING_PAGE } from '../../utils/marketing-analytics';

/**
 * Sign-up that lands on the Integrations tab, where MCP is set up, instead of
 * dropping the user on the dashboard. `auth-section` reads `redirectPath`.
 */
const MCP_SIGNUP_HREF = `${APP_ROUTES.LOGIN}?${REDIRECT_PATH}=${encodeURIComponent(
	`${APP_ROUTES.SETTINGS}?tab=integrations`
)}`;

function McpPage() {
	useIdleIntercom();

	useEffect(() => {
		emitMixpanelEvent(mixpanelEvents.VIEWED_MCP_PAGE, {
			feature: MIXPANEL_APP_FEATURES.MCP_PAGE,
		});
	}, []);

	return (
		<>
			<McpStructuredData />
			<div className="flex min-h-screen w-full flex-col bg-[#F8F8F8] md:[&_.landing-width]:max-w-[960px]">
				<HeaderSection page={MARKETING_PAGE.MCP} />

				<div className="flex w-full flex-1 flex-col items-center justify-start overflow-x-hidden pt-8 md:pt-16">
					<McpHeroSection />
					<McpCapabilitiesSection />
					<McpHowToConnectSection />
					<McpClientSetupSection />
					<McpComparisonSection />
					<FAQSection
						faqData={MCP_FAQ_DATA}
						title="Frequently asked questions"
						headingClassName="text-balance !text-[28px] tracking-tight md:!text-[40px]"
					/>
					<CTASection
						page={MARKETING_PAGE.MCP}
						title="Ready to try?"
						buttonText="Start for free"
						href={MCP_SIGNUP_HREF}
						headingClassName="text-balance !text-[28px] tracking-tight md:!text-[40px]"
					/>
				</div>

				<FooterSection />
			</div>
		</>
	);
}

export default McpPage;
